/**
 * Lumavie About Our Promise - Initial Card Position
 * 
 * Scrolls to the second (middle) card on page load
 */

(function () {
    'use strict';

    function scrollToMiddleCard() {
        const cardsContainers = document.querySelectorAll('.lumavie-about-our-promise__cards');

        cardsContainers.forEach(container => {
            const cards = container.querySelectorAll('.lumavie-about-our-promise__card');

            // Only proceed if we have at least 2 cards
            if (cards.length < 2) return;

            // Get the second card
            const secondCard = cards[1];
            if (!secondCard) return;

            // Calculate scroll position to center the second card
            const cardWidth = secondCard.offsetWidth;
            const gap = 12; // var(--cards-gap-mobile)

            // Scroll to second card position: (card width + gap) * 1
            const scrollPosition = (cardWidth + gap) * 1;

            // Scroll without animation on initial load
            container.scrollLeft = scrollPosition;
        });
    }

    // Execute when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scrollToMiddleCard);
    } else {
        scrollToMiddleCard();
    }
})();
